<script lang="ts" setup>
import { useAttrs, computed } from 'vue'
import { Label, type LabelProps } from 'reka-ui'
import { Check } from 'lucide-vue-next'
import { useFormField } from './useFormField'
import { cn } from '@/lib/utils'

defineOptions({
  inheritAttrs: false,
})
const props = defineProps<LabelProps>()

const { error, formItemId, valid, isDirty } = useFormField()
const { class: className, ...rest } = useAttrs() as import('vue').SetupContext['attrs']

const showCheck = computed(() => isDirty.value && valid.value)
</script>

<template>
  <Label
    :class="cn(
      'flex items-start justify-between text-sm tracking-tight font-medium text-foreground text-left',
      className ?? '',
    )"
    :for="formItemId"
    v-bind="rest"
  >
    <span><slot /></span>
    <span v-if="error" aria-hidden="true" class="text-sm font-normal text-destructive">{{ error }}</span>
    <Check v-else-if="showCheck" aria-hidden="true" class="h-5 w-5 text-green-500 stroke-[2.5]" />
  </Label>
</template>
